/**
 * The Platform Roadmap module's permission vocabulary.
 *
 * Two rungs, like the product roadmap. The tech team edits; anyone given `view` (product,
 * leadership, support) can see what deploys when without being able to drag it. There is no
 * per-project ownership check — in the prototype anyone on the team moved anyone's bar, and the
 * ripple checklist, not the owner, is what guards banking.
 *
 * Comments need `edit` too: a viewer's question belongs in the team's channel. Marking your own
 * mentions read needs only `view`.
 */
import { defineModulePermissions } from '@noissue/authz';

export const PLATFORM_ROADMAP = defineModulePermissions({
  id: 'platform-roadmap',
  name: 'Platform Roadmap',
  icon: 'rocket',
  permissions: {
    view: {
      label: 'View the platform roadmap',
      description: 'See swimlanes, projects, their dates, ripples and comments.',
    },
    edit: {
      label: 'Edit the platform roadmap',
      description:
        'Add and move projects, manage swimlanes, tick ripples, comment and bank projects.',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'edit', label: 'Edit', grants: ['view', 'edit'] },
  ],
});
